export default __webpack_public_path__ + "django.57c467cb.png";